import React from "react"
import { Box, Switch, Typography } from "@mui/material"
import { dsColorNew } from "@palette"
import { AppSitesAutocomplete } from "@components/Autocomplete"
import useDsRepricingDataInfo from "Pages/DsRepricing/Page/@hooks/useDataInfo"
import { dsRepricingDrawerData, dsRepricingOriginalData } from "Pages/DsRepricing/Page/@signals"
import { enrichFilterIds } from "Pages/DsRepricing/Page/@utils/filterEnrich"

export default function DsRepricingExcludeWebs() {
	const d = dsRepricingDrawerData.peek()
	const { dataInfo: idsInfo, setDataInfo: setIds } = useDsRepricingDataInfo(d.filterGroupSites ?? [])
	const { dataInfo: exclInfo, setDataInfo: setExcl } = useDsRepricingDataInfo(d.filterGroupSitesExclusion ?? false)

	const isExclusion = exclInfo.value
	const ids = idsInfo.value ?? []

	const updateMode = (checked) => setExcl(checked, 'filterGroupSitesExclusion')
	const updateIds = (_, opts) => setIds(opts ?? [], 'filterGroupSites')

	return (
		<Box>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
				<Switch checked={isExclusion} onChange={e => updateMode(e.target.checked)} size="small"/>
				<Typography sx={{ fontSize: 14, color: dsColorNew.textDark, fontWeight: 500 }}>
					{isExclusion ? 'Exclude sites' : 'Include sites'}
				</Typography>
			</Box>
			{/* Individual sites, not site GROUPS. The engine compares the
			    scope against `RESULTS_CH.id_site`, a Price Seeker master
			    site id, and a group id is not one — so a scope built from
			    groups matched no site and said nothing. The tenant had no
			    groups either, which is why the field simply looked empty.
			    Same catalogue Rate Cards reads, so the two agree. */}
			<AppSitesAutocomplete
				multiple
				label="Sites"
				placeholder={isExclusion ? 'All sites except…' : 'All sites'}
				value={ids.map(o => o?.value ?? o)}
				onChange={updateIds}
				onAjax={options => { enrichFilterIds('filterGroupSites', options, dsRepricingDrawerData, dsRepricingOriginalData); return options }}
			/>
		</Box>
	)
}